import { useTranslation } from "react-i18next";
import * as yup from "yup";

export const useValidateName = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    name: yup.string().required(t("Name is required")),
  });
};
